import React from "react";
import { Link } from "react-router-dom";
import { Box, Button } from "@mui/material";
import { useCookieConsent } from "../context/CookieConsentContext";

export default function CookieBanner() {
	const { consent, acceptAll, rejectAll, openPreferences } = useCookieConsent();

	// Solo mostrar si aún no hay decisión
	if (consent !== null) return null;

	return (
		<Box
			component="div"
			sx={{
				position: "fixed",
				bottom: 0,
				left: 0,
				right: 0,
				zIndex: 1300,
				p: 2,
				px: { xs: 2, sm: 3 },
				backgroundColor: "rgba(15, 23, 42, 0.97)",
				color: "#fff",
				boxShadow: "0 -4px 24px rgba(0,0,0,0.15)",
			}}
		>
			<Box
				sx={{
					maxWidth: 900,
					margin: "0 auto",
					display: "flex",
					flexDirection: { xs: "column", sm: "row" },
					alignItems: { xs: "stretch", sm: "center" },
					gap: 2,
				}}
			>
				<Box sx={{ flex: 1, fontSize: "0.875rem", lineHeight: 1.5 }}>
					Usamos cookies técnicas (necesarias) y, si lo aceptas, analíticas para
					mejorar la experiencia. Puedes aceptar todas, rechazar las opcionales o
					configurar preferencias.{" "}
					<Box
						component={Link}
						to="/legal/cookies"
						rel="nofollow"
						sx={{ color: "#A5B4FC", textDecoration: "underline" }}
					>
						Más información
					</Box>
				</Box>
				<Box
					sx={{
						display: "flex",
						flexWrap: "wrap",
						gap: 1,
						alignItems: "center",
					}}
				>
					<Button
						size="small"
						variant="outlined"
						onClick={rejectAll}
						sx={{
							color: "#fff",
							borderColor: "rgba(255,255,255,0.5)",
							"&:hover": { borderColor: "#fff", backgroundColor: "rgba(255,255,255,0.08)" },
						}}
					>
						Rechazar
					</Button>
					<Button
						size="small"
						variant="outlined"
						onClick={openPreferences}
						sx={{
							color: "#fff",
							borderColor: "rgba(255,255,255,0.5)",
							"&:hover": { borderColor: "#fff", backgroundColor: "rgba(255,255,255,0.08)" },
						}}
					>
						Configurar preferencias
					</Button>
					<Button
						size="small"
						variant="contained"
						onClick={acceptAll}
						sx={{
							backgroundColor: "#6366F1",
							"&:hover": { backgroundColor: "#4F46E5" },
						}}
					>
						Aceptar todas
					</Button>
				</Box>
			</Box>
		</Box>
	);
}
